import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Video } from '../../components/video/Video';
import { TitulosDinamicos } from '../../components/TitulosDinamicos';
import { Preload } from '../../components/Preload';
import { ManualesLateral } from '../../components/ManualesLateral';
import { getManualesManualesVideo } from '../../actions/appActions';


export const Bossanova = () => {


    const dispatch = useDispatch()

    const {loading} = useSelector( state => state.ui )

    const [databossanova, setDataBossanova] = useState([])

   

    useEffect(() => {
        
        async function getBossanovas(){
            
            const url = '/v1/bossanova';
            const resultado = await dispatch( getManualesManualesVideo(url) )
            setDataBossanova(resultado)
            
        }
        getBossanovas()
    }, [])


    
    
     if (loading) {
         return (
             <Preload/>
         )
     }


    return (
        <>
            <div className="row own-container m-t-2">
                <div className="col-md-8 col-sm-12">
                   <Video   data={databossanova} />
                </div>
                <div className="col-md-4">
                    <TitulosDinamicos 
                        title={"Manuales Bossanova"}
                    />
                    <ManualesLateral data={databossanova}/>
                </div>
            </div>
        </>
    )
}
